import { Grid } from "@mui/material";
import SeoStepHeader from "./components/SeoStepHeader";
import MxOverlayLoading from "@rf-l1/loading/mx-overlay-loading/MxOverlayLoading";
import { useSeoFormActions } from "@rf/property/module/components/property-form/store/slices/SeoFormSlice";
import SeoStepV2Form from "./components/SeoStepV2Form";
import { msgSeoLoading } from "./util/seo-menssages.util";

const SeoDataFormSection = () => {
  const { isLoadingGenerateAiDescription } = useSeoFormActions();
  return (
    <MxOverlayLoading
      mode="auto"
      id="seo-data-form-section"
      messages={msgSeoLoading}
      loading={isLoadingGenerateAiDescription}
      time={40000}
      top="10%"
    >
      <Grid container alignSelf={"flex-start"} rowGap={3}>
        <SeoStepHeader />
        <SeoStepV2Form />
      </Grid>
    </MxOverlayLoading>
  );
};

export default SeoDataFormSection;
